"use strict";

const HintSidebarPort = {
  add: (app) => {
    if (app.ports.enableToggleShortcutPort) {
      app.ports.enableToggleShortcutPort.subscribe(() => {
        document.addEventListener("keydown", function keydownHandler(e) {
          if (
            (e.metaKey || e.ctrlKey) &&
            e.shiftKey &&
            e.key.toLowerCase() === "h"
          ) {
            app.ports.toggleTriggeredPort.send(null);
            e.preventDefault();
          }
        });
      });
    }

    app.ports.startResizePort.subscribe(() => {
      const minWidth = 200;
      const maxWidthRatio = 0.8;

      const onMouseMove = (e) => {
        const newWidth = window.innerWidth - e.clientX;
        const clamped = Math.min(
          Math.max(newWidth, minWidth),
          window.innerWidth * maxWidthRatio,
        );
        document.documentElement.style.setProperty(
          "--hint-sidebar-width",
          clamped + "px",
        );
      };

      const cleanup = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", cleanup);
        window.removeEventListener("blur", cleanup);
        document.body.style.cursor = "";
        document.body.style.userSelect = "";
      };

      document.body.style.cursor = "col-resize";
      document.body.style.userSelect = "none";
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", cleanup);
      window.addEventListener("blur", cleanup);
    });
  },
};

module.exports = HintSidebarPort;
